import React from 'react';
import { Popup } from 'semantic-ui-react';

export const PopupUi = ({...props}) => {
    return <Popup {...props} />
}

export default PopupUi